/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  CreateUpdateCommonFinancialGroupRequest,
  CreateUpdateInstituteRequest,
  CreateUpdatePersonRequest,
  FinancialGroupLightResponse,
  InstituteLightResponse,
  InstituteResponse,
  LinkInstitutePersonRequest,
  MedicalPersonFinancialGroupRequest,
  MedicalPersonFinancialGroupResponse,
  MedicalPersonLightResponse,
  MedicalPersonResponse,
  PersonInstituteLightResponse,
  PersonLightResponse,
  UpdateUsersPermissionsRequest,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    CreateUpdateCommonFinancialGroupRequestFromJSON,
    CreateUpdateCommonFinancialGroupRequestToJSON,
    CreateUpdateInstituteRequestFromJSON,
    CreateUpdateInstituteRequestToJSON,
    CreateUpdatePersonRequestFromJSON,
    CreateUpdatePersonRequestToJSON,
    FinancialGroupLightResponseFromJSON,
    FinancialGroupLightResponseToJSON,
    InstituteLightResponseFromJSON,
    InstituteLightResponseToJSON,
    InstituteResponseFromJSON,
    InstituteResponseToJSON,
    LinkInstitutePersonRequestFromJSON,
    LinkInstitutePersonRequestToJSON,
    MedicalPersonFinancialGroupRequestFromJSON,
    MedicalPersonFinancialGroupRequestToJSON,
    MedicalPersonFinancialGroupResponseFromJSON,
    MedicalPersonFinancialGroupResponseToJSON,
    MedicalPersonLightResponseFromJSON,
    MedicalPersonLightResponseToJSON,
    MedicalPersonResponseFromJSON,
    MedicalPersonResponseToJSON,
    PersonInstituteLightResponseFromJSON,
    PersonInstituteLightResponseToJSON,
    PersonLightResponseFromJSON,
    PersonLightResponseToJSON,
    UpdateUsersPermissionsRequestFromJSON,
    UpdateUsersPermissionsRequestToJSON,
} from '../models/index';

export interface AddAdminUserInInstituteRequest {
    instituteId: string;
    createUpdatePersonRequest: CreateUpdatePersonRequest;
}

export interface AddCommonFinancialGroupRequest {
    createUpdateCommonFinancialGroupRequest: CreateUpdateCommonFinancialGroupRequest;
}

export interface AddInstituteRequest {
    createUpdateInstituteRequest: CreateUpdateInstituteRequest;
}

export interface AddMedicalPersonRequest {
    createUpdatePersonRequest: CreateUpdatePersonRequest;
}

export interface AddMedicalPersonInCommonFinancialGroupRequest {
    financialGroupId: number;
    medicalPersonFinancialGroupRequest: MedicalPersonFinancialGroupRequest;
}

export interface AdminUpdateInstituteRequest {
    instituteId: string;
    createUpdateInstituteRequest: CreateUpdateInstituteRequest;
}

export interface AdminUpdatePermissionRequest {
    personId: string;
    updateUsersPermissionsRequest: UpdateUsersPermissionsRequest;
}

export interface DeleteLinkInstituteAtPersonRequest {
    personId: string;
    linkInstitutePersonRequest: LinkInstitutePersonRequest;
}

export interface DeleteMedicalPersonInCommonFinancialGroupRequest {
    financialGroupId: number;
    personId: string;
}

export interface GetAdminUserByInstituteRequest {
    instituteId: string;
}

export interface GetAllMedicalPersonByCommonFinancialGroupRequest {
    financialGroupId: number;
}

export interface GetInstituteByIdRequest {
    instituteId: string;
}

export interface GetInstituteByMedicalPersonRequest {
    personId: string;
}

export interface GetMedicalPersonByUuidRequest {
    personId: string;
}

export interface GetMedicalPersonsByInstituteRequest {
    instituteId: string;
}

export interface LinkInstituteAtPersonRequest {
    personId: string;
    linkInstitutePersonRequest: LinkInstitutePersonRequest;
}

export interface SearchInstituteRequest {
    type?: string;
}

export interface UpdateCommonFinancialGroupRequest {
    financialGroupId: number;
    createUpdateCommonFinancialGroupRequest: CreateUpdateCommonFinancialGroupRequest;
}

export interface UpdateMedicalPersonRequest {
    personId: string;
    createUpdatePersonRequest: CreateUpdatePersonRequest;
}

export interface UpdateMedicalPersonInCommonFinancialGroupRequest {
    financialGroupId: number;
    personId: string;
    isOwner?: boolean;
}

/**
 * 
 */
export class AdminApi extends runtime.BaseAPI {

    /**
     * Add admin user for an institute
     */
    async addAdminUserInInstituteRaw(requestParameters: AddAdminUserInInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PersonLightResponse>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling addAdminUserInInstitute().'
            );
        }

        if (requestParameters['createUpdatePersonRequest'] == null) {
            throw new runtime.RequiredError(
                'createUpdatePersonRequest',
                'Required parameter "createUpdatePersonRequest" was null or undefined when calling addAdminUserInInstitute().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/institute/{institute_id}/admin-user`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdatePersonRequestToJSON(requestParameters['createUpdatePersonRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PersonLightResponseFromJSON(jsonValue));
    }

    /**
     * Add admin user for an institute
     */
    async addAdminUserInInstitute(requestParameters: AddAdminUserInInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PersonLightResponse> {
        const response = await this.addAdminUserInInstituteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add a common financial group
     */
    async addCommonFinancialGroupRaw(requestParameters: AddCommonFinancialGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FinancialGroupLightResponse>>> {
        if (requestParameters['createUpdateCommonFinancialGroupRequest'] == null) {
            throw new runtime.RequiredError(
                'createUpdateCommonFinancialGroupRequest',
                'Required parameter "createUpdateCommonFinancialGroupRequest" was null or undefined when calling addCommonFinancialGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/common-financial-group`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateCommonFinancialGroupRequestToJSON(requestParameters['createUpdateCommonFinancialGroupRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FinancialGroupLightResponseFromJSON));
    }

    /**
     * Add a common financial group
     */
    async addCommonFinancialGroup(requestParameters: AddCommonFinancialGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FinancialGroupLightResponse>> {
        const response = await this.addCommonFinancialGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add a new institute
     */
    async addInstituteRaw(requestParameters: AddInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InstituteLightResponse>> {
        if (requestParameters['createUpdateInstituteRequest'] == null) {
            throw new runtime.RequiredError(
                'createUpdateInstituteRequest',
                'Required parameter "createUpdateInstituteRequest" was null or undefined when calling addInstitute().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/institute`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateInstituteRequestToJSON(requestParameters['createUpdateInstituteRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InstituteLightResponseFromJSON(jsonValue));
    }

    /**
     * Add a new institute
     */
    async addInstitute(requestParameters: AddInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InstituteLightResponse> {
        const response = await this.addInstituteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add a medical person
     */
    async addMedicalPersonRaw(requestParameters: AddMedicalPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MedicalPersonLightResponse>> {
        if (requestParameters['createUpdatePersonRequest'] == null) {
            throw new runtime.RequiredError(
                'createUpdatePersonRequest',
                'Required parameter "createUpdatePersonRequest" was null or undefined when calling addMedicalPerson().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/medical-person`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdatePersonRequestToJSON(requestParameters['createUpdatePersonRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MedicalPersonLightResponseFromJSON(jsonValue));
    }

    /**
     * Add a medical person
     */
    async addMedicalPerson(requestParameters: AddMedicalPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MedicalPersonLightResponse> {
        const response = await this.addMedicalPersonRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add a medical person in common financial group
     */
    async addMedicalPersonInCommonFinancialGroupRaw(requestParameters: AddMedicalPersonInCommonFinancialGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MedicalPersonFinancialGroupResponse>>> {
        if (requestParameters['financialGroupId'] == null) {
            throw new runtime.RequiredError(
                'financialGroupId',
                'Required parameter "financialGroupId" was null or undefined when calling addMedicalPersonInCommonFinancialGroup().'
            );
        }

        if (requestParameters['medicalPersonFinancialGroupRequest'] == null) {
            throw new runtime.RequiredError(
                'medicalPersonFinancialGroupRequest',
                'Required parameter "medicalPersonFinancialGroupRequest" was null or undefined when calling addMedicalPersonInCommonFinancialGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/common-financial-group/{financial_group_id}/medical-person`.replace(`{${"financial_group_id"}}`, encodeURIComponent(String(requestParameters['financialGroupId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MedicalPersonFinancialGroupRequestToJSON(requestParameters['medicalPersonFinancialGroupRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MedicalPersonFinancialGroupResponseFromJSON));
    }

    /**
     * Add a medical person in common financial group
     */
    async addMedicalPersonInCommonFinancialGroup(requestParameters: AddMedicalPersonInCommonFinancialGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MedicalPersonFinancialGroupResponse>> {
        const response = await this.addMedicalPersonInCommonFinancialGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * update an institute
     */
    async adminUpdateInstituteRaw(requestParameters: AdminUpdateInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InstituteResponse>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling adminUpdateInstitute().'
            );
        }

        if (requestParameters['createUpdateInstituteRequest'] == null) {
            throw new runtime.RequiredError(
                'createUpdateInstituteRequest',
                'Required parameter "createUpdateInstituteRequest" was null or undefined when calling adminUpdateInstitute().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/institute/{institute_id}`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateInstituteRequestToJSON(requestParameters['createUpdateInstituteRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InstituteResponseFromJSON(jsonValue));
    }

    /**
     * update an institute
     */
    async adminUpdateInstitute(requestParameters: AdminUpdateInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InstituteResponse> {
        const response = await this.adminUpdateInstituteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a permission
     */
    async adminUpdatePermissionRaw(requestParameters: AdminUpdatePermissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling adminUpdatePermission().'
            );
        }

        if (requestParameters['updateUsersPermissionsRequest'] == null) {
            throw new runtime.RequiredError(
                'updateUsersPermissionsRequest',
                'Required parameter "updateUsersPermissionsRequest" was null or undefined when calling adminUpdatePermission().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/medical-person/{person_id}/permissions`.replace(`{${"person_id"}}`, encodeURIComponent(String(requestParameters['personId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateUsersPermissionsRequestToJSON(requestParameters['updateUsersPermissionsRequest']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Update a permission
     */
    async adminUpdatePermission(requestParameters: AdminUpdatePermissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.adminUpdatePermissionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete link between an institute and a person
     */
    async deleteLinkInstituteAtPersonRaw(requestParameters: DeleteLinkInstituteAtPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MedicalPersonLightResponse>> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling deleteLinkInstituteAtPerson().'
            );
        }

        if (requestParameters['linkInstitutePersonRequest'] == null) {
            throw new runtime.RequiredError(
                'linkInstitutePersonRequest',
                'Required parameter "linkInstitutePersonRequest" was null or undefined when calling deleteLinkInstituteAtPerson().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/medical-person/{person_id}/institutes`.replace(`{${"person_id"}}`, encodeURIComponent(String(requestParameters['personId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: LinkInstitutePersonRequestToJSON(requestParameters['linkInstitutePersonRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MedicalPersonLightResponseFromJSON(jsonValue));
    }

    /**
     * Delete link between an institute and a person
     */
    async deleteLinkInstituteAtPerson(requestParameters: DeleteLinkInstituteAtPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MedicalPersonLightResponse> {
        const response = await this.deleteLinkInstituteAtPersonRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a medical person in common financial group
     */
    async deleteMedicalPersonInCommonFinancialGroupRaw(requestParameters: DeleteMedicalPersonInCommonFinancialGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MedicalPersonFinancialGroupResponse>>> {
        if (requestParameters['financialGroupId'] == null) {
            throw new runtime.RequiredError(
                'financialGroupId',
                'Required parameter "financialGroupId" was null or undefined when calling deleteMedicalPersonInCommonFinancialGroup().'
            );
        }

        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling deleteMedicalPersonInCommonFinancialGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/common-financial-group/{financial_group_id}/medical-person/{person_id}`.replace(`{${"financial_group_id"}}`, encodeURIComponent(String(requestParameters['financialGroupId']))).replace(`{${"person_id"}}`, encodeURIComponent(String(requestParameters['personId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MedicalPersonFinancialGroupResponseFromJSON));
    }

    /**
     * Delete a medical person in common financial group
     */
    async deleteMedicalPersonInCommonFinancialGroup(requestParameters: DeleteMedicalPersonInCommonFinancialGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MedicalPersonFinancialGroupResponse>> {
        const response = await this.deleteMedicalPersonInCommonFinancialGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get admin user for an institute
     */
    async getAdminUserByInstituteRaw(requestParameters: GetAdminUserByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PersonLightResponse>>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling getAdminUserByInstitute().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/institute/{institute_id}/admin-user`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PersonLightResponseFromJSON));
    }

    /**
     * Get admin user for an institute
     */
    async getAdminUserByInstitute(requestParameters: GetAdminUserByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PersonLightResponse>> {
        const response = await this.getAdminUserByInstituteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all common financial group
     */
    async getAllCommonFinancialGroupRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FinancialGroupLightResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/common-financial-group`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FinancialGroupLightResponseFromJSON));
    }

    /**
     * Get all common financial group
     */
    async getAllCommonFinancialGroup(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FinancialGroupLightResponse>> {
        const response = await this.getAllCommonFinancialGroupRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get all medical person
     */
    async getAllMedicalPersonRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MedicalPersonLightResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/medical-person`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MedicalPersonLightResponseFromJSON));
    }

    /**
     * Get all medical person
     */
    async getAllMedicalPerson(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MedicalPersonLightResponse>> {
        const response = await this.getAllMedicalPersonRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get all medical person of common financial group
     */
    async getAllMedicalPersonByCommonFinancialGroupRaw(requestParameters: GetAllMedicalPersonByCommonFinancialGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MedicalPersonFinancialGroupResponse>>> {
        if (requestParameters['financialGroupId'] == null) {
            throw new runtime.RequiredError(
                'financialGroupId',
                'Required parameter "financialGroupId" was null or undefined when calling getAllMedicalPersonByCommonFinancialGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/common-financial-group/{financial_group_id}/medical-person`.replace(`{${"financial_group_id"}}`, encodeURIComponent(String(requestParameters['financialGroupId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MedicalPersonFinancialGroupResponseFromJSON));
    }

    /**
     * Get all medical person of common financial group
     */
    async getAllMedicalPersonByCommonFinancialGroup(requestParameters: GetAllMedicalPersonByCommonFinancialGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MedicalPersonFinancialGroupResponse>> {
        const response = await this.getAllMedicalPersonByCommonFinancialGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get institute by id
     */
    async getInstituteByIdRaw(requestParameters: GetInstituteByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InstituteResponse>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling getInstituteById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/institute/{institute_id}`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InstituteResponseFromJSON(jsonValue));
    }

    /**
     * Get institute by id
     */
    async getInstituteById(requestParameters: GetInstituteByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InstituteResponse> {
        const response = await this.getInstituteByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get institutes for a medical person
     */
    async getInstituteByMedicalPersonRaw(requestParameters: GetInstituteByMedicalPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PersonInstituteLightResponse>>> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling getInstituteByMedicalPerson().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/medical-person/{person_id}/institutes`.replace(`{${"person_id"}}`, encodeURIComponent(String(requestParameters['personId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PersonInstituteLightResponseFromJSON));
    }

    /**
     * Get institutes for a medical person
     */
    async getInstituteByMedicalPerson(requestParameters: GetInstituteByMedicalPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PersonInstituteLightResponse>> {
        const response = await this.getInstituteByMedicalPersonRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a medical person by his id
     */
    async getMedicalPersonByUuidRaw(requestParameters: GetMedicalPersonByUuidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MedicalPersonResponse>> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling getMedicalPersonByUuid().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/medical-person/{person_id}`.replace(`{${"person_id"}}`, encodeURIComponent(String(requestParameters['personId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MedicalPersonResponseFromJSON(jsonValue));
    }

    /**
     * Get a medical person by his id
     */
    async getMedicalPersonByUuid(requestParameters: GetMedicalPersonByUuidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MedicalPersonResponse> {
        const response = await this.getMedicalPersonByUuidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get medical person by institute
     */
    async getMedicalPersonsByInstituteRaw(requestParameters: GetMedicalPersonsByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MedicalPersonLightResponse>>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling getMedicalPersonsByInstitute().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/institute/{institute_id}/medical-person`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MedicalPersonLightResponseFromJSON));
    }

    /**
     * Get medical person by institute
     */
    async getMedicalPersonsByInstitute(requestParameters: GetMedicalPersonsByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MedicalPersonLightResponse>> {
        const response = await this.getMedicalPersonsByInstituteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Link an institute at a person
     */
    async linkInstituteAtPersonRaw(requestParameters: LinkInstituteAtPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MedicalPersonLightResponse>> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling linkInstituteAtPerson().'
            );
        }

        if (requestParameters['linkInstitutePersonRequest'] == null) {
            throw new runtime.RequiredError(
                'linkInstitutePersonRequest',
                'Required parameter "linkInstitutePersonRequest" was null or undefined when calling linkInstituteAtPerson().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/medical-person/{person_id}/institutes`.replace(`{${"person_id"}}`, encodeURIComponent(String(requestParameters['personId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: LinkInstitutePersonRequestToJSON(requestParameters['linkInstitutePersonRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MedicalPersonLightResponseFromJSON(jsonValue));
    }

    /**
     * Link an institute at a person
     */
    async linkInstituteAtPerson(requestParameters: LinkInstituteAtPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MedicalPersonLightResponse> {
        const response = await this.linkInstituteAtPersonRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search institute
     */
    async searchInstituteRaw(requestParameters: SearchInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<InstituteLightResponse>>> {
        const queryParameters: any = {};

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/institute`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InstituteLightResponseFromJSON));
    }

    /**
     * Search institute
     */
    async searchInstitute(requestParameters: SearchInstituteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<InstituteLightResponse>> {
        const response = await this.searchInstituteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a common financial group
     */
    async updateCommonFinancialGroupRaw(requestParameters: UpdateCommonFinancialGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FinancialGroupLightResponse>>> {
        if (requestParameters['financialGroupId'] == null) {
            throw new runtime.RequiredError(
                'financialGroupId',
                'Required parameter "financialGroupId" was null or undefined when calling updateCommonFinancialGroup().'
            );
        }

        if (requestParameters['createUpdateCommonFinancialGroupRequest'] == null) {
            throw new runtime.RequiredError(
                'createUpdateCommonFinancialGroupRequest',
                'Required parameter "createUpdateCommonFinancialGroupRequest" was null or undefined when calling updateCommonFinancialGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/common-financial-group/{financial_group_id}`.replace(`{${"financial_group_id"}}`, encodeURIComponent(String(requestParameters['financialGroupId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateCommonFinancialGroupRequestToJSON(requestParameters['createUpdateCommonFinancialGroupRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FinancialGroupLightResponseFromJSON));
    }

    /**
     * Update a common financial group
     */
    async updateCommonFinancialGroup(requestParameters: UpdateCommonFinancialGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FinancialGroupLightResponse>> {
        const response = await this.updateCommonFinancialGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a medical person
     */
    async updateMedicalPersonRaw(requestParameters: UpdateMedicalPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MedicalPersonLightResponse>> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling updateMedicalPerson().'
            );
        }

        if (requestParameters['createUpdatePersonRequest'] == null) {
            throw new runtime.RequiredError(
                'createUpdatePersonRequest',
                'Required parameter "createUpdatePersonRequest" was null or undefined when calling updateMedicalPerson().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/medical-person/{person_id}`.replace(`{${"person_id"}}`, encodeURIComponent(String(requestParameters['personId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdatePersonRequestToJSON(requestParameters['createUpdatePersonRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MedicalPersonLightResponseFromJSON(jsonValue));
    }

    /**
     * Update a medical person
     */
    async updateMedicalPerson(requestParameters: UpdateMedicalPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MedicalPersonLightResponse> {
        const response = await this.updateMedicalPersonRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a medical person in common financial group
     */
    async updateMedicalPersonInCommonFinancialGroupRaw(requestParameters: UpdateMedicalPersonInCommonFinancialGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MedicalPersonFinancialGroupResponse>>> {
        if (requestParameters['financialGroupId'] == null) {
            throw new runtime.RequiredError(
                'financialGroupId',
                'Required parameter "financialGroupId" was null or undefined when calling updateMedicalPersonInCommonFinancialGroup().'
            );
        }

        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling updateMedicalPersonInCommonFinancialGroup().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['isOwner'] != null) {
            queryParameters['isOwner'] = requestParameters['isOwner'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/common-financial-group/{financial_group_id}/medical-person/{person_id}`.replace(`{${"financial_group_id"}}`, encodeURIComponent(String(requestParameters['financialGroupId']))).replace(`{${"person_id"}}`, encodeURIComponent(String(requestParameters['personId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MedicalPersonFinancialGroupResponseFromJSON));
    }

    /**
     * Update a medical person in common financial group
     */
    async updateMedicalPersonInCommonFinancialGroup(requestParameters: UpdateMedicalPersonInCommonFinancialGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MedicalPersonFinancialGroupResponse>> {
        const response = await this.updateMedicalPersonInCommonFinancialGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
